import type { RouteObject } from 'react-router';

import { PHOTO_PROMPT_PATH, PROFILE_PATH } from '../../app/config';

/** W7. Inside the shell, behind `RequireAuth` + `RequirePinChanged`. */
export const profileRoutes: RouteObject[] = [
  {
    path: PROFILE_PATH,
    lazy: async () => ({ Component: (await import('./ProfilePage')).ProfilePage }),
  },
];

/**
 * W9 (P-01). Authenticated and PIN-current, but **outside** the shell and
 * outside `RequirePhotoPrompted` — a screen that redirected to itself would be
 * an infinite loop, and a full-screen offer has no business wearing a tab bar.
 */
export const photoPromptRoute: RouteObject = {
  path: PHOTO_PROMPT_PATH,
  lazy: async () => ({ Component: (await import('./PhotoPromptPage')).PhotoPromptPage }),
};
